import {
  Button,
  ModalManager,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BsCalendarEvent, BsHeart, BsHeartFill } from "react-icons/bs";
import { FaMapMarkerAlt, FaTags } from "react-icons/fa";
import { IoMdCar } from "react-icons/io";
import { RiParkingBoxLine } from "react-icons/ri";
import {
  calculateDistance,
  currencyFormatter,
} from "../../redux/services/utility";
import RegularButton from "../Buttons/RegularButton";
import RegularModal from "../Modals/RegularModal";
import { AiOutlineCloseCircle } from "react-icons/ai";
import "../../../src/pages/Home/Style.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import MuiAlert from "../../pages/MuiAlert/MuiAlert";
import { useSelector } from "react-redux";
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";
import { getUserData, setAuth } from "../../redux/slices/authSlice";
import {
  useLoginSendOtpMutation,
  useLoginverifyOtpMutation,
} from "../../redux/services/authApi";
import { Formik } from "formik";
import * as Yup from "yup";
import OTPInput from "react-otp-input";
import { useAppDispatch } from "../../redux/app/hooks";
import { setCustomer } from "../../redux/slices/customerSlice";
import FuelType from "../../assets/FuelType.png";
import Cancellation from "../../assets/Cancellation.png";
import ExtrakmFare from "../../assets/ExtraKm.png";
import { MdTimeline, MdLocalGasStation, MdCancel, MdOutlineRoomService, MdOutlineDirectionsCar, MdDirectionsCar } from "react-icons/md";
import { setSelectedParking } from "../../redux/slices/parkingSlice";
import { setBookingDetails } from "../../redux/slices/navSlice";
import ArrowImage from "../../assets/ArrowImage.png"

type Props = {
  type: "PCTR" | "PCTL" | "Regular " | "Luxury Parking";
  data: null | any;
  onClick?: () => void;
  toggleFavourites: (parking: any) => void;
  checkIn?: any;
  checkOut?: any;
  timezones?: any;
  index?: any;
  userLat?: any;
  userLng?: any;
  parkingLat?: any;
  parkingLng?: any;
  locationData?: any;
  fetchParkingDetailsAsync?: any;
  selectedTZOptions?: any;
  parkingcategoryName?: any;
  tripType?: any;
  packageType?: any;
  duration: any;
  distance: any;
};

const SigninSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const SigninSchemas = Yup.object().shape({
  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .min(10, "Mobile number must be 10 digits only")
    .max(10, "Mobile number must be 10 digits only"),
});

const ParkingComponent = (props: Props) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [visibles, setVisibles] = React.useState(false);
  const [visibless, setVisibless] = React.useState(false);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const userData = useSelector(getUserData);
  const [findCustomerDetailById, findByIdResponse] =
    useFindCustomerDetailByIdMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [emaildata, setEmailData]: any = useState();
  const [mobiledata, setMobileData]: any = useState();
  const [mode, setMode]: any = useState(false);
  const [loginUser, loginUserResponse] = useLoginSendOtpMutation();
  const [loginWith, setLoginWith] = useState("Email");
  const [value, setValue] = useState("");
  const [verifyOTP, OTPResponse] = useLoginverifyOtpMutation();
  const dispatch = useAppDispatch();
  const [seconds, setSeconds] = useState(60);
  const [activeTab, setActiveTab] = useState<"inclusions" | "exclusions">("inclusions");
  //console.log("Props Data:",props.data);
  let valueForOTP = value.length;

  const handleLogin = () => {
    verifyOTP({
      phoneNo: mode === true ? mobiledata : "",
      category: "UTCUST",
      emailFlag: mode === true ? false : true,
      email: mode === true ? "" : emaildata.toLowerCase(),
      otp: value,
    });
  };

  useEffect(() => {
    if (OTPResponse.isSuccess) {
      localStorage.setItem("user", JSON.stringify(OTPResponse.data));
      localStorage.setItem("isLoggedIn", "true");
      dispatch(setAuth(OTPResponse.data));
      dispatch(setCustomer(OTPResponse.data));
      viewModalClosed();
    }
    if (OTPResponse.isError) {
      const newpage: any = OTPResponse?.error;
      const errorCode: any = newpage.data?.serviceErrors[0].errorCode;
      const newMsg: any = newpage.data?.serviceErrors[0].msg;
      setStatusCode({
        type: "error",
        code: errorCode
          ? errorCode === "INVALID_OTP_EXCEPTION"
            ? newMsg
            : newMsg
          : "CONSENT_FORM_ERROR",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [OTPResponse.isSuccess, OTPResponse.isError]);

  const resendOTP = () => {
    loginUser({
      phoneNo: mode === true ? mobiledata : "",
      category: "UTCUST",
      emailFlag: mode === true ? false : true,
      email: mode === true ? "" : emaildata.toLowerCase(),
    });
  };

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  useEffect(() => {
    if (loginUserResponse.isSuccess) {
      setSeconds(60);
      setStatusCode({
        type: "success",
        code:
          mode === false
            ? "OTP has been successfully sent to your registered email"
            : "OTP has been successfully sent to your registered phone number",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [loginUserResponse.isSuccess]);

  const loginWithEmailAndPassword = (email: string, flag: string) => {
    loginUser({
      phoneNo: flag === "Mobile" ? email : "",
      category: "UTCUST",
      emailFlag: flag === "Mobile" ? false : true,
      email: flag === "Mobile" ? "" : email.toLowerCase(),
    });
  };

  const handleLoginWithEmail = (values: any) => {
    setEmailData(values.email);
    setMode(false);
    loginWithEmailAndPassword(values.email, "Email");
  };

  const handleLoginWithMobile = (values: any) => {
    setMode(true);
    setMobileData(values.mobileNumber);
    loginWithEmailAndPassword(values.mobileNumber, "Mobile");
  };

  useEffect(() => {
    if (loginUserResponse.isSuccess) {
      setLoginWith("OTP");
      setStatusCode({
        type: "success",
        code: "NUMBER_SENT_SUCCESS",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }

    if (loginUserResponse.isError) {
      let newMassege: any = loginUserResponse.error;
      let finaleMsg =
        newMassege?.data &&
        newMassege?.data?.serviceErrors &&
        newMassege?.data?.serviceErrors[0];
      setStatusCode({
        type: "error",
        code: "EMAIL_SENT_FAILURE",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [loginUserResponse.isSuccess, loginUserResponse.isError]);

  const getIsLoggedIn = () => {
    let isLoggedIn: any = localStorage.getItem("isLoggedIn");
    isLoggedIn = JSON.parse(isLoggedIn);
    setIsLoggedIn(isLoggedIn);
  };

  useEffect(() => {
    getIsLoggedIn();
  }, [isLoggedIn]);

  const viewMoreClosed = () => {
    setVisibles(false);
  };

  const viewModalClosed = () => {
    setVisibless(false);
  };

  //console.log("Props Data:",props);

  return (
    <>
      <div className="mb-4 block md:hidden lg:block">
        <div className="w-full flex flex-col mt-4 md:mt-0 md:flex-row bg-[#F9F4EF] p-4 rounded-3xl cursor-pointer relative overflow-hidden">
          {/* Image Section */}
          <div
            className="w-full md:w-[200px] h-[150px] rounded-lg relative flex-shrink-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(${props?.data?.imageList?.[0]?.filePreSignedUrl})`,
            }}
          ></div>
          {/* Details Section */}
          <div className="w-full flex flex-col lg:flex-row md:gap-4 gap-0">
            <div className="w-full lg:w-1/3 md:p-4 p-0">
              {/* Model Name & Rating in One Line */}
              <div className="flex items-center justify-between w-full">
                <h3 className="text-red-600 font-bold text-lg md:text-xl">
                  {props?.data?.vehicleDetailObj?.model}
                </h3>
                <Rating
                  name="vehicle-rating"
                  value={props?.data?.parkingSpaceRating?.toFixed(1) || 1}
                  precision={0.5}
                  readOnly
                  size="small"
                  sx={{ color: "#ED1C24" }}
                />
              </div>
              {/* Vehicle Features */}
              <ul className="flex flex-wrap text-[#58595B] text-xs md:text-sm mt-2 gap-x-4 gap-y-1">
                <li className="flex items-center gap-2">
                  <span className="text-red-500">•</span> {props?.data?.vehicleDetailObj?.typeDisplayValue}
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-red-500">•</span> {props?.data?.vehicleDetailObj?.isAc ? "AC" : "Non AC"}
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-red-500">•</span> {props?.data?.vehicleDetailObj?.seatingCapacity} Seats
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-red-500">•</span> {props?.data?.vehicleDetailObj?.luggageCapacity} Luggage
                </li>
              </ul>
              {/** <p className="mt-3 font-bold text-[#58595B] lg:text-md text-sm">Compact Car</p> */}
            </div>
            {/* Information Section 
            <div className="w-full md:mt-0 mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-gray-700">
              {[
                {
                  img: ExtrakmFare,
                  title: "Extra km fare",
                  text: `₹${props?.data?.selectedParkingCategoryRes?.commExtraRate}/km after ${Math.ceil(
                    props?.tripType?.typeName === "OutStation Round Trip"
                      ? (props?.data?.distanceInKm || 0) * 2
                      : props?.data?.distanceInKm || 0
                  )} kms`,
                },
                {
                  img: FuelType,
                  title: "Fuel Type",
                  text: props?.data?.vehicleDetailObj?.fuelType,
                },
                {
                  img: Cancellation,
                  title: "Cancellation",
                  text: `Free till ${props?.data?.selectedParkingCategoryRes?.cancellationDueTime} hour of departure`,
                },
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                  <img src={item.img} alt={item.title} className="xl:w-10 xl:h-10 lg:w-9 lg:h-9 w-6 h-6" />
                  <div className="w-[40%]">
                    <p className="font-semibold md:text-sm text-xs text-[#58595B]">{item.title}</p>
                    <p className="md:text-xs text-[8px] text-[#58595B]">{item.text}</p>
                  </div>
                </div>
              ))}
            </div> */}
            <div className="w-full md:mt-0 mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-gray-700">
            {[ 
              {
                    img: ExtrakmFare,
                    title: "Extra km fare",
                    text: `₹${props?.data?.selectedParkingCategoryRes?.commExtraRate}/km after ${Math.ceil(
                      props?.tripType?.typeName === "Hourly Rental"
                        ? props?.distance || 0
                        : props?.tripType?.typeName === "OutStation Round Trip"
                        ? (props?.data?.distanceInKm || 0) * 2
                        : props?.data?.distanceInKm || 0 
                    )} kms`,
                  },
              {
                img: FuelType,
                title: "Fuel Type",
                text: props?.data?.vehicleDetailObj?.fuelType,
              },
              {
                img: Cancellation,
                title: "Cancellation",
                text: `Free till ${props?.data?.selectedParkingCategoryRes?.cancellationDueTime} hour of departure`,
              },
            ].map((item, index) =>
              item ? ( 
                <div key={index} className="flex items-center gap-2">
                  {item.img && ( 
                    <img
                      src={item.img}
                      alt={item.title}
                      className="xl:w-10 xl:h-10 lg:w-9 lg:h-9 w-6 h-6"
                    />
                  )}
                  <div className="w-[40%]">
                    <p className="font-semibold md:text-sm text-xs text-[#58595B]">{item.title}</p>
                    <p className="md:text-xs text-[8px] text-[#58595B]">{item.text}</p>
                  </div>
                </div>
              ) : null 
            )}
          </div>
          </div>
          {/* Pricing and Booking Section */}
          <div className="flex flex-col items-center justify-center w-full lg:w-auto mt-4 lg:mt-0">
            {props?.data?.total !== null && (
              <p className="text-lg md:text-xl font-bold text-[#58595B]">
                ₹{(props?.data?.total ?? 0).toFixed(2)}
              </p>
            )}
            <button
              onClick={() => {
                dispatch(setSelectedParking(props.data));
                const payload = {
                  flag: props.duration === 0 ? "city" : undefined,
                  selectedParking: props?.data,
                  checkIn: props?.checkIn,
                  checkOut: props?.checkOut,
                  selectedTZOptions: props?.selectedTZOptions,
                  formatted_address: props?.locationData?.formatted_address,
                  lat: props?.locationData?.lat,
                  lng: props?.locationData?.lng,
                  parkingCategoryName: props.parkingcategoryName,
                  tripType: props.tripType,
                  packageType: props.packageType,
                  duration: props.duration,
                  distance: props.distance,
                  bookingDetail: props.data,
                };
                localStorage.setItem("bookingDetails", JSON.stringify(payload));
                dispatch(setBookingDetails(payload));
                navigate(`/profile/Booking-detail?bookingId=${props?.data?.id}`);
                props?.fetchParkingDetailsAsync?.(props?.data?.id);
              }}
              className="w-[140px] text-white bg-[#ED1C24] hover:bg-[#ED1C24] text-sm font-semibold rounded-full py-2 mt-2 shadow-md mb-8 md:mb-0"
            >
              Confirm Booking
            </button>
          </div>
          {/* Toggle Button */}
          {!isExpanded && (
            <div
              className="absolute left-1/2 transform -translate-x-1/2 bottom-4 cursor-pointer"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <img src={ArrowImage} alt="Toggle Details" className="md:w-6 md:h-6 w-5 w-5 transition-transform" />
            </div>
          )}
        </div>
        {/* Expanded Section */}
        {isExpanded && (
          <div className="mx-8 relative">
            <div className="bg-[#ED1C24] p-4 sm:p-6 shadow flex flex-col md:flex-row gap-4 rounded-xl mb-2 items-center">
              {/* Inclusions Section */}
              <div className="inclusions w-full md:w-[43%] flex flex-col items-center text-center gap-2">
                <h3 className="font-semibold text-black text-xs sm:text-sm md:text-sm lg:text-base bg-white 
      px-2 py-1 md:px-3 md:py-1 rounded-full">
                  Inclusions
                </h3>
                <div className="text-white text-xs sm:text-sm md:text-sm lg:text-base mt-1">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: props?.data?.inclusions || "No inclusions available.",
                    }}
                  />
                </div>
              </div>

              {/* Divider for Desktop */}
              <div className="hidden md:flex border-l-2 border-dotted h-20 w-[4%] justify-center items-center lg:ml-6"></div>

              {/* Exclusions Section */}
              <div className="exclusions w-full md:w-[43%] flex flex-col items-center text-center gap-2">
                <h3 className="font-semibold text-black text-xs sm:text-sm md:text-sm lg:text-base bg-white 
      px-2 py-1 md:px-3 md:py-1 rounded-full">
                  Exclusions
                </h3>
                <div className="text-white text-xs sm:text-sm md:text-sm lg:text-base">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: props?.data?.exclusions || "No exclusions available.",
                    }}
                  />
                  {props?.tripType?.typeName === "Airport Drop" && (
                    <div>
                      The Airport entry charge, if applicable, is not included in the fare and will be charged extra.
                    </div>
                  )}
                </div>
              </div>

              {/* Toggle Button */}
              <div
                className="absolute left-1/2 transform -translate-x-1/2 -top-3 bg-white rounded-full p-1 shadow-md cursor-pointer"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <img
                  src={ArrowImage}
                  alt="Toggle Details"
                  className={`w-4 h-4 md:w-5 md:h-5 transition-transform ${isExpanded ? "rotate-180" : ""
                    }`}
                />
              </div>
            </div>

          </div>
        )}
      </div>
      <div className="mb-4 hidden lg:hidden md:block">
        <div className="w-full flex flex-col bg-[#F9F4EF] p-4 rounded-3xl cursor-pointer relative overflow-hidden">
          {/* Image Section */}
          <div
            className="w-full lg:w-[200px] md:w-[650px] md:h-[400px] h-[200px] rounded-lg lg:mr-4 relative flex-shrink-0"
            style={{
              backgroundImage: `url(${props?.data?.imageList?.[0]?.filePreSignedUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
          <div className="w-full flex flex-col mt-1">
            <div className="flex items-center justify-start w-full space-x-2">
              <h3 className="text-red-600 font-bold text-2xl md:text-2xl">
                {props?.data?.vehicleDetailObj?.model}
              </h3>
              <h3 className="text-gray-500 font-semibold text-lg md:text-xl">
                | Compact Car
              </h3>
            </div>
            {/* Rating */}
            <div className="flex items-center mt-2">
              <Rating
                name="vehicle-rating"
                value={props?.data?.parkingSpaceRating?.toFixed(1) || 1}
                precision={0.5}
                readOnly
                size="small"
                sx={{ color: "#ED1C24" }}
              />
            </div>
            {/* Vehicle Features in One Line */}
            <ul className="flex flex-nowrap items-center gap-2 mt-2 text-[#58595B] text-xs md:text-sm overflow-hidden">
              <li className="flex items-center gap-x-1">
                <span className="text-red-600">•</span>
                {props?.data?.vehicleDetailObj?.typeDisplayValue}
              </li>
              <li className="flex items-center gap-x-1">
                <span className="text-red-600">•</span>
                {props?.data?.vehicleDetailObj?.isAc ? "AC" : "Non AC"}
              </li>
              <li className="flex items-center gap-x-1">
                <span className="text-red-600">•</span>
                {props?.data?.vehicleDetailObj?.seatingCapacity} Seats
              </li>
              <li className="flex items-center gap-x-1">
                <span className="text-red-600">•</span>
                {props?.data?.vehicleDetailObj?.luggageCapacity} Luggage
              </li>
            </ul>
            {/* Fuel, Cancellation, Extra KM Fare in One Line */}
            <div className="w-full grid grid-cols-1 mt-2 md:grid-cols-3 gap-4 text-gray-700">
              {[
                {
                  img: ExtrakmFare,
                  title: "Extra km fare",
                  text: `₹${props?.data?.selectedParkingCategoryRes?.commExtraRate}/km after ${Math.ceil(
                      props?.tripType?.typeName === "Hourly Rental"
                        ? props?.distance || 0
                        : props?.tripType?.typeName === "OutStation Round Trip"
                        ? (props?.data?.distanceInKm || 0) * 2
                        : props?.data?.distanceInKm || 0 
                    )} kms`,
                },
                {
                  img: FuelType,
                  title: "Fuel Type",
                  text: props?.data?.vehicleDetailObj?.fuelType,
                },
                {
                  img: Cancellation,
                  title: "Cancellation",
                  text: `Free till ${props?.data?.selectedParkingCategoryRes?.cancellationDueTime} hour of departure`,
                },
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                  <img src={item.img} alt={item.title} className="md:w-10 md:h-10 w-8 h-8" />
                  <div>
                    <p className="font-semibold md:text-sm text-xs text-[#58595B]">{item.title}</p>
                    <p className="md:text-xs text-[8px] text-[#58595B]">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* Pricing (Centered) */}
            <div className="flex justify-center mt-2">
              {props?.data?.total !== null && (
                <p className="text-lg md:text-xl font-bold text-[#58595B]">
                  ₹{(props?.data?.total ?? 0).toFixed(2)}
                </p>
              )}
            </div>
            {/* Confirm Booking Button */}
            <div className="flex justify-center mt-2">
              <button
                onClick={() => {
                  dispatch(setSelectedParking(props.data));
                  const payload = {
                    flag: props.duration === 0 ? "city" : undefined,
                    selectedParking: props?.data,
                    checkIn: props?.checkIn,
                    checkOut: props?.checkOut,
                    selectedTZOptions: props?.selectedTZOptions,
                    formatted_address: props?.locationData?.formatted_address,
                    lat: props?.locationData?.lat,
                    lng: props?.locationData?.lng,
                    parkingCategoryName: props.parkingcategoryName,
                    tripType: props.tripType,
                    packageType: props.packageType,
                    duration: props.duration,
                    distance: props.distance,
                    bookingDetail: props.data,
                  };
                  localStorage.setItem("bookingDetails", JSON.stringify(payload));
                  dispatch(setBookingDetails(payload));
                  navigate(`/profile/Booking-detail?bookingId=${props?.data?.id}`);
                  props?.fetchParkingDetailsAsync?.(props?.data?.id);
                }}
                className="w-full md:w-[140px] text-white bg-[#ED1C24] hover:bg-[#ED1C24] text-sm font-semibold rounded-full py-2"
              >
                Confirm Booking
              </button>
            </div>

          </div>
          {/* Toggle Button */}
          {!isExpanded && (
            <div
              className="mt-2 cursor-pointer flex justify-center"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <img src={ArrowImage} alt="Toggle Details" className="md:w-6 md:h-6 w-5 h-5 transition-transform" />
            </div>

          )}
        </div>
        {/* Expanded Section */}
        {isExpanded && (
          <div className="mx-8 relative">
            <div className="bg-[#ED1C24] p-6 shadow justify-center flex md:flex-row flex-col gap-4 rounded-xl mb-2">

              <div className="inclusions md:w-[43%] w-full gap-6 flex md:flex-col flex-row items-center pr-4 mb-4 sm:mb-0 sm:pr-4">
                <h3 className="font-semibold text-black text-[16px] bg-white px-4 py-1 rounded-full">Inclusions</h3>
                <div className="text-white text-sm md:text-base mt-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: props?.data?.inclusions || "No inclusions available.",
                    }}
                  />
                </div>
              </div>
              <div className="md:flex hidden border-l-2 mt-2 justify-center ml-6 items-center h-24 w-[4%] border-dotted "></div>
              <div className="exclusions gap-6 flex md:flex-col flex-row md:w-[43%] w-full  pr-4 items-center mb-4 sm:mb-0 sm:pr-4">
                <h3 className="font-semibold text-black text-center text-[16px] bg-white px-4 py-1 rounded-full">Exclusions</h3>
                <div className="text-white text-sm md:text-base">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: props?.data?.exclusions || "No exclusions available.",
                    }}
                  />
                  {props?.tripType?.typeName === "Airport Drop" && (
                    <div>The Airport entry charge, if applicable, is not included in the fare and will be charged extra.</div>
                  )}
                </div>
              </div>

              {/* Toggle Button */}
              <div
                className="absolute left-1/2 transform -translate-x-1/2 -top-3 bg-white rounded-full p-1 shadow-md cursor-pointer"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <img
                  src={ArrowImage}
                  alt="Toggle Details"
                  className={`md:w-6 md:h-6 w-5 h-5 transition-transform ${isExpanded ? "rotate-180" : ""
                    }`}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ParkingComponent;
